import type { AreaCatalog } from '../area';
import type { work as en } from '../en/work';

export const work = {
  'work.page.title': 'Aufgaben',
  'work.page.count': { one: '{count} Aufgabe', other: '{count} Aufgaben' },
  'work.page.empty': 'Noch nichts da.',
  'work.page.addFirst': 'Erste Aufgabe hinzufügen',
  'work.page.showAll': 'Alle anzeigen',

  'work.sort.touched': 'Zuletzt geändert',
  'work.sort.changed': 'Zuletzt aktualisiert',
  'work.sort.viewed': 'Zuletzt angesehen',
  'work.sort.created': 'Neueste',
  'work.sort.priority': 'Priorität',
  'work.sort.alpha': 'A–Z',

  'work.group.flow': 'Ablauf',
  'work.group.stage': 'Phase',
  'work.group.view': 'Board',
  'work.group.parent': 'Übergeordnete Aufgabe',
  'work.group.tag': 'Tag',
  'work.group.priority': 'Priorität',
  'work.group.custom': 'Eigene Abschnitte',
  'work.group.none': 'Keine Gruppierung',

  'work.section.must': 'Muss',
  'work.section.should': 'Soll',
  'work.section.could': 'Kann',
  'work.section.noPriority': 'Keine Priorität',
  'work.section.noParent': 'Keine übergeordnete Aufgabe',
  'work.section.noTag': 'Kein Tag',
  'work.section.noView': 'Auf keinem Board',
  'work.section.noFlow': 'Kein Ablauf',
  'work.section.other': 'Sonstige',
  'work.section.flowStage': '{flow}: {stage}',
} as const satisfies AreaCatalog<typeof en>;
